/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Generation } from './';
import {
    GenerationFromJSON,
    GenerationFromJSONTyped,
    GenerationToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancersPerGeneration
 */
export interface FreelancersPerGeneration {
    /**
     * 
     * @type {number}
     * @memberof FreelancersPerGeneration
     */
    count: number;
    /**
     * 
     * @type {Generation}
     * @memberof FreelancersPerGeneration
     */
    generation: Generation;
}

/**
 * Check if a given object implements the FreelancersPerGeneration interface.
 */
export function instanceOfFreelancersPerGeneration(value: object): value is FreelancersPerGeneration {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('generation' in value) || value['generation'] === undefined) return false;
    return true;
}

export function FreelancersPerGenerationFromJSON(json: any): FreelancersPerGeneration {
    return FreelancersPerGenerationFromJSONTyped(json, false);
}

export function FreelancersPerGenerationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancersPerGeneration {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'generation': GenerationFromJSON(json['generation']),
    };
}

export function FreelancersPerGenerationToJSON(value?: FreelancersPerGeneration | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'generation': GenerationToJSON(value['generation']),
    };
}

